import { render, staticRenderFns } from "./DanhSachChinhSach.vue?vue&type=template&id=b815826e&scoped=true&"
import script from "./DanhSachChinhSach.vue?vue&type=script&lang=js&"
export * from "./DanhSachChinhSach.vue?vue&type=script&lang=js&"
import style0 from "./DanhSachChinhSach.vue?vue&type=style&index=0&id=b815826e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b815826e",
  null
  
)

export default component.exports